import React, { PureComponent, Fragment } from 'react'; 
import { Container, Col, Row } from 'bootstrap-4-react';    
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Autoplay, Navigation, Pagination,EffectFade } from 'swiper';

// swiper bundle styles
import 'swiper/swiper-bundle.min.css';

// swiper core styles
import 'swiper/swiper.min.css'; 
 


import axios from 'axios';
import * as apiUrl from '../../../apiUrl';


import { useParams } from "react-router-dom";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}
 
SwiperCore.use([Autoplay, Navigation, Pagination,EffectFade]);
class InteriorExterior extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {

     

       
    


        formValues3: [{ section_id: "", slider_image: [], imageURL: "" }],
        errors3: [{ section_id: "", slider_image: "" }],

        section_title5: "",
        section_description5: "",


        formValues4: [{ section_id: "", slider_image: [], imageURL: "" }],
        errors4: [{ section_id: "", slider_image: "" }],


        section_title6: "",
        section_description6: "",

     

    };

   
   



}

async componentDidUpdate(prevProps) {


    if ( this.props.params.id !== prevProps.params.id ) {

  const { id } = this.props.params;

  let self = this;

  

  axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + id)
      .then(res => {



          self.setState({
             
              section_title5: res.data[0].section_title5,
              section_description5: res.data[0].section_description5,
             

   
              section_title6: res.data[0].section_title6,
              section_description6: res.data[0].section_description6,
            


             


          });


          


        

          


          



          let formValues3 = [];

          res.data[0].exterior.forEach((element) => {


              element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

              formValues3.push(element);

              








          });

          

        

          this.setState({ formValues3 });



          let formValues4 = [];

          res.data[0].interior.forEach((element) => {


              element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

              formValues4.push(element);

             








          });

         

          this.setState({ formValues4 });




     



      }

      );

    }

}


async componentDidMount() {

  const { id } = this.props.params;

  let self = this;

  

  axios.post(apiUrl.apiUrl + '/propertiesinnerpage/edit_propertiesinner_post/' + id)
      .then(res => {



          self.setState({
             
              section_title5: res.data[0].section_title5,
              section_description5: res.data[0].section_description5,
             

   
              section_title6: res.data[0].section_title6,
              section_description6: res.data[0].section_description6,
            


             


          });


          


        

          


          



          let formValues3 = [];

          res.data[0].exterior.forEach((element) => {


              element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

              formValues3.push(element);

              








          });

          

        

          this.setState({ formValues3 });



          let formValues4 = [];

          res.data[0].interior.forEach((element) => {


              element.imageURL = apiUrl.apiUrl + "/mvd/propertiesinnerpagepostsection/" + element.slider_image;

              formValues4.push(element);

             








          });

         

          this.setState({ formValues4 });




     



      }

      );




}
        
    render() { 
        return (
          <Fragment>  
            <Container fluid className="exteriorInteriorSec darkBlueBG homegallerySec"> 
                <Row className="marginZero">
                <Col lg={1}></Col>
                <Col lg={11}>  
                <Row className="d-flex align-content-center flex-wrap justify-content-center homegalleryDiv">
                        <Col lg={5} md={5}>  
                          <Row> 
                            <Col lg={12} className="position-absolute d-flex align-content-center flex-wrap justify-content-center text-center galHeading">
                              <div className="homegallerHead darkBlueBG">
                                  <h2 className="whiteColor canelaMedium secHeading">Exterior</h2>
                              </div> 
                            </Col> 
                          </Row> 
                         <div className="gallerySwiperDiv">
                            <Swiper className="exteriorSwiper" autoplay={false} navigation={true} slidesPerView={1} spaceBetween={30}>

                            {

this.state.formValues3.map((item) => (
                                <SwiperSlide className="gallerySlider" key={'InteriorExterior_pop'+item.id}>  
                                      <div className="homeGalleryimg">  
                                          <img src={item.imageURL} className="img-fluid" alt="exteriorImage1" />
                                      </div>  
                                </SwiperSlide>  
                                 

))

}
                            </Swiper>
                         </div>

                        </Col>
                        <Col lg={6} md={6}>  

                                <div className="exteriorDescription whiteColor">
                                    <h2 className="canelaMedium">{this.state.section_title5} </h2>
                                    <p className="">{this.state.section_description5} </p>
                                            
                                </div>
                          

                        </Col>
                    </Row>



                    <Row className="d-flex align-content-center flex-wrap justify-content-center homegalleryDiv reverseRow">
                   
                        <Col lg={6} md={6}>  

                                <div className="exteriorDescription whiteColor">
                                    <h2 className="canelaMedium">{this.state.section_title6} </h2>
                                    <p className="">{this.state.section_description6} </p>
                                            
                                </div>  
                        </Col>
                        <Col lg={5} md={5}>  
                          <Row> 
                            <Col lg={12} className="position-absolute d-flex align-content-center flex-wrap justify-content-center text-center galHeading">
                              <div className="homegallerHead darkBlueBG">
                                  <h2 className="whiteColor canelaMedium secHeading">Interior</h2>
                              </div> 
                            </Col> 
                          </Row> 
                         <div className="gallerySwiperDiv">
                            <Swiper className="exteriorSwiper" autoplay={false} navigation={true} slidesPerView={1} spaceBetween={50}>
                            {

this.state.formValues4.map((item) => (
                                <SwiperSlide className="gallerySlider" key={'InteriorExterior_popioop_'+item.id}>  
                                      <div className="homeGalleryimg">  
                                          <img src={item.imageURL} className="img-fluid" alt="exteriorImage1" />
                                      </div>  
                                </SwiperSlide>  
                                 

))

}  
                            </Swiper>
                         </div>

                        </Col>
                    </Row>

 
                </Col>  
                
                </Row>
            </Container>  

                      
          </Fragment>
        )
      }
}


//export default InteriorExterior

export default withParams(InteriorExterior);